(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tl-business-hero"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('tl-business-scene')) {
    customElements.define('tl-business-scene', class extends HTMLElement {
      connectedCallback() {
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = [];
        const visual = this.querySelector('.tl-business-hero__visual');
        if (!visual || !window.IntersectionObserver || !visual.animate) return;
        this.stopMotion = () => { if (this.motion.matches) this.animations.forEach(a => a.cancel()); };
        this.motion.addEventListener('change', this.stopMotion);
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          if (this.motion.matches) return;
          const end = 'translateY(0) scale(1)';
          this.animations.push(visual.animate([
            {transform: 'translateY(24px) scale(.985)', opacity: .85},
            {transform: end, opacity: 1}
          ], {duration: 700, easing: 'cubic-bezier(.16,1,.3,1)'}));
        }, {threshold: .12});
        this.observer.observe(visual);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.animations?.forEach(a => a.cancel());
        if (this.stopMotion) this.motion.removeEventListener('change', this.stopMotion);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-catalog-browser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-catalog-browser')) {
    customElements.define('tl-catalog-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const controls = this.querySelector('[data-catalog-controls]');
        const input = this.querySelector('[data-catalog-search]');
        const count = this.querySelector('[data-catalog-count]');
        const empty = this.querySelector('[data-catalog-empty]');
        const cards = Array.from(this.querySelectorAll('[data-catalog-model]'));
        if (!controls || !input || !count || !empty) return;
        const normalize = value => value.normalize('NFKC').toLocaleLowerCase().trim();
        const update = () => {
          const query = normalize(input.value);
          let visible = 0;
          cards.forEach(card => {
            card.hidden = !normalize(card.dataset.search || '').includes(query);
            if (!card.hidden) visible += 1;
          });
          count.textContent = String(visible);
          empty.hidden = visible > 0;
        };
        input.addEventListener('input', update);
        this.querySelector('[data-catalog-reset]')?.addEventListener('click', () => {
          input.value = '';
          update();
          input.focus();
        });
        controls.hidden = false;
        const reset = this.querySelector('[data-catalog-reset]');
        if (reset) reset.hidden = cards.length === 0;
        update();
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!preference.matches && 'IntersectionObserver' in window) {
          this.enterObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.dataset.catalogEnter = 'complete';
              this.enterObserver.unobserve(entry.target);
            });
          }, { threshold: .12 });
          cards.forEach(card => {
            card.dataset.catalogEnter = 'pending';
            this.enterObserver.observe(card);
          });
        }
        this.motionChange = () => {
          if (!preference.matches) return;
          cards.forEach(card => { card.dataset.catalogEnter = 'complete'; });
          this.enterObserver?.disconnect();
        };
        this.motionPreference = preference;
        preference.addEventListener('change', this.motionChange);
      }
      disconnectedCallback() {
        this.enterObserver?.disconnect();
        this.querySelectorAll('[data-catalog-enter]').forEach(card => { card.dataset.catalogEnter = 'complete'; });
        this.motionPreference?.removeEventListener('change', this.motionChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-company-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-company-film')) {
    customElements.define('tl-company-film', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.track = this.querySelector('[data-film-track]');
        this.frames = [...this.querySelectorAll('[data-film-frame]')];
        if (!this.track || !this.frames.length) return;
        this.animations = [];
        this.previous = this.querySelector('[data-film-previous]');
        this.next = this.querySelector('[data-film-next]');
        this.count = this.querySelector('[data-film-count]');
        this.querySelector('[data-film-controls]').hidden = this.frames.length < 2;
        this.previous.addEventListener('click', () => this.go(-1), {signal: this.controller.signal});
        this.next.addEventListener('click', () => this.go(1), {signal: this.controller.signal});
        this.track.addEventListener('scroll', () => this.update(), {passive: true, signal: this.controller.signal});
        ['pointerdown', 'wheel', 'keydown'].forEach(type => this.track.addEventListener(type, () => this.cancelScroll(), {passive: true, signal: this.controller.signal}));
        window.addEventListener('resize', () => { this.cancelScroll(); this.update(); }, {passive: true, signal: this.controller.signal});
        this.motion.addEventListener('change', () => { if (this.motion.matches) { this.cancelScroll(); this.animations.forEach(a => a.cancel()); } }, {signal: this.controller.signal});
        if (window.IntersectionObserver) {
          this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (!this.motion.matches && entry.target.animate) this.animations.push(entry.target.animate([{transform: 'scale(.99)', opacity: .88}, {transform: 'scale(1)', opacity: 1}], {duration: 600, easing: 'cubic-bezier(.16,1,.3,1)'}));
          }), {threshold: .2});
          this.frames.forEach(frame => this.observer.observe(frame));
        }
        this.update();
      }
      offsets() { return this.frames.map(frame => frame.offsetLeft - this.frames[0].offsetLeft); }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offsets = this.offsets();
        this.index = offsets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(offsets[best] - this.track.scrollLeft) ? i : best, 0);
        if (this.track.scrollLeft >= max - 2) this.index = this.frames.length - 1;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        this.count.textContent = String(this.index + 1).padStart(2, '0') + ' / ' + String(this.frames.length).padStart(2, '0');
      }
      go(direction) {
        this.cancelScroll();
        const index = Math.min(this.frames.length - 1, Math.max(0, this.index + direction));
        const target = Math.min(this.offsets()[index], this.track.scrollWidth - this.track.clientWidth);
        if (this.motion.matches) { this.track.scrollLeft = target; return; }
        const from = this.track.scrollLeft;
        const started = performance.now();
        this.track.style.scrollSnapType = 'none';
        const tick = now => {
          const progress = Math.min(1, (now - started) / 650);
          this.track.scrollLeft = from + (target - from) * (1 - Math.pow(1 - progress, 3));
          if (progress < 1) this.frame = requestAnimationFrame(tick);
          else { this.frame = 0; this.track.style.scrollSnapType = ''; this.update(); }
        };
        this.frame = requestAnimationFrame(tick);
      }
      cancelScroll() { cancelAnimationFrame(this.frame); this.frame = 0; if (this.track) this.track.style.scrollSnapType = ''; }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.cancelScroll(); this.animations?.forEach(a => a.cancel()); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-factory-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-factory-video')) {
  customElements.define('tl-factory-video', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.video = this.querySelector('[data-factory-video]');
      if (!this.video) return;
      this.bound = true;
      this.status = this.querySelector('[data-video-status]');
      this.onClick = event => {
        const button = event.target.closest('[data-video-seek]');
        if (!button || !this.contains(button)) return;
        const seconds = Number(button.dataset.videoSeek);
        if (!Number.isFinite(seconds)) return;
        this.pendingChapter = { seconds: Math.max(0, seconds), title: button.dataset.chapterTitle || '' };
        if (this.video.readyState >= 1) this.seekChapter();
        else this.video.load();
      };
      this.onMetadata = () => this.seekChapter();
      this.onError = () => {
        this.pendingChapter = null;
        this.video.hidden = true;
        const fallback = this.querySelector('[data-video-fallback]');
        if (fallback) fallback.hidden = false;
        this.querySelectorAll('[data-video-seek]').forEach(button => { button.disabled = true; });
        if (this.status) this.status.textContent = this.status.dataset.errorLabel;
      };
      this.addEventListener('click', this.onClick);
      this.video.addEventListener('loadedmetadata', this.onMetadata);
      this.video.addEventListener('error', this.onError);
    }
    seekChapter() {
      if (!this.pendingChapter || !this.video) return;
      const chapter = this.pendingChapter;
      this.pendingChapter = null;
      const maximum = Number.isFinite(this.video.duration) ? Math.max(0, this.video.duration - .05) : chapter.seconds;
      try { this.video.currentTime = Math.min(chapter.seconds, maximum); }
      catch { return; }
      if (this.status) this.status.textContent = `${this.status.dataset.seekLabel} ${chapter.title}`;
      const playAttempt = this.video.play();
      if (playAttempt?.catch) playAttempt.catch(() => {});
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.video?.removeEventListener('loadedmetadata', this.onMetadata);
      this.video?.removeEventListener('error', this.onError);
      this.video?.pause();
      this.pendingChapter = null;
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-hero-carousel')) customElements.define('tl-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const { signal } = this._abort;
      const slides = [...this.querySelectorAll('[data-slide]')];
      const dots = [...this.querySelectorAll('[data-dot]')];
      if (slides.length < 2) return;
      let index = 0;
      const go = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      };
      this.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1), { signal });
      this.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1), { signal });
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), { signal }));

      const delay = Number(this.dataset.autoplay) || 0;
      if (delay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let timer;
        const start = () => { timer = setInterval(() => go(index + 1), delay); };
        const stop = () => clearInterval(timer);
        start();
        this.addEventListener('mouseenter', stop, { signal });
        this.addEventListener('mouseleave', start, { signal });
        this.addEventListener('focusin', stop, { signal });
        this.addEventListener('focusout', start, { signal });
        document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()), { signal });
      }
      go(0);
    }
    disconnectedCallback() { this._abort?.abort(); this._abort = null; }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-partner-brief"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('tl-purchase-brief')) {
    customElements.define('tl-purchase-brief', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.routes = [...this.querySelectorAll('.tl-partner-brief__route')];
        this.animations = new Map();
        this.targets = new Map();
        this.link = this.querySelector('[data-scenario-link]');
        this.originalHref = this.link?.href;
        this.routes.forEach(route => {
          route.querySelector('summary').addEventListener('click', event => {
            event.preventDefault();
            const shouldOpen = !(this.targets.get(route) ?? route.open);
            this.routes.forEach(item => this.setOpen(item, item === route && shouldOpen));
            this.setContext(shouldOpen ? route : null);
          }, {signal: this.controller.signal});
        });
        this.motion.addEventListener('change', () => {
          if (!this.motion.matches) return;
          this.routes.forEach(route => this.setOpen(route, this.targets.get(route) ?? route.open, true));
        }, {signal: this.controller.signal});
      }
      setOpen(route, open, immediate = false) {
        const start = route.getBoundingClientRect().height;
        this.animations.get(route)?.cancel();
        this.targets.set(route, open);
        if (immediate || this.motion.matches || !route.animate) { route.open = open; route.style.overflow = ''; return; }
        const hadOpen = route.open;
        route.open = true;
        const end = open ? route.getBoundingClientRect().height : route.querySelector('summary').getBoundingClientRect().height + 1;
        if (!hadOpen && !open) { route.open = false; return; }
        route.style.overflow = 'hidden';
        const animation = route.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 320, easing: 'cubic-bezier(.2,.65,.3,1)'});
        this.animations.set(route, animation);
        animation.onfinish = () => { route.open = open; route.style.overflow = ''; this.animations.delete(route); };
      }
      setContext(route) {
        const status = this.querySelector('[data-scenario-status]');
        const label = this.querySelector('[data-scenario-label]')?.textContent.trim() || '';
        const selected = this.querySelector('[data-selected-scenario]');
        const title = route?.querySelector('[data-scenario-title]')?.textContent.trim() || '';
        if (status && selected) {
          status.hidden = !route;
          selected.textContent = title;
          if (route && !this.motion.matches && status.animate) status.animate([{translate: '0 12px', opacity: .4}, {translate: '0 0', opacity: 1}], {duration: 320, easing: 'ease-out'});
        }
        if (this.link && this.originalHref) {
          const url = new URL(this.originalHref, location.href);
          if (route && url.origin === location.origin) url.searchParams.set('brief', [label, title].filter(Boolean).join(': '));
          this.link.href = route ? url.href : this.originalHref;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.animations?.forEach(a => a.cancel());
        this.routes?.forEach(route => { route.open = this.targets.get(route) ?? route.open; route.style.overflow = ''; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-product-detail')) {
    customElements.define('tl-product-detail', class extends HTMLElement {
      connectedCallback() {
        if (this.stopEvents) return;
        const abort = new AbortController();
        this.stopEvents = abort;
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const image = this.querySelector('.tl-product-detail__image');
        const slot = this.querySelector('[data-product-nav-slot]');
        const links = [...this.querySelectorAll('[data-product-jump]')];
        const targets = links.map(link => document.getElementById(link.hash.slice(1)));
        const header = document.querySelector('.tl-header');
        const update = () => {
          this.frame = null;
          if (document.hidden) return;
          const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 76;
          const offset = Math.min(150, headerBottom + 8);
          const rootInset = parseFloat(window.getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
          this.style.setProperty('--product-nav-top', `${offset}px`);
          if (slot) this.dataset.navDocked = String(slot.getBoundingClientRect().top < offset);
          let active = 0;
          targets.forEach((target, index) => {
            if (!target) return;
            const targetInset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
            const activationLine = Math.max(offset + 150, rootInset + targetInset + 2);
            if (target.getBoundingClientRect().top <= activationLine) active = index;
          });
          links.forEach((link, index) => {
            if (index === active) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
          if (!image) return;
          if (preference.matches || window.innerWidth < 700) {
            image.style.removeProperty('--product-shift');
            return;
          }
          const bounds = this.getBoundingClientRect();
          if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
          const progress = (window.innerHeight * .5 - bounds.top) / Math.max(bounds.height, 1);
          const shift = Math.max(-10, Math.min(10, (progress - .35) * 36));
          image.style.setProperty('--product-shift', `${shift.toFixed(2)}px`);
        };
        const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
        window.addEventListener('scroll', schedule, { passive: true, signal: abort.signal });
        window.addEventListener('resize', schedule, { passive: true, signal: abort.signal });
        window.addEventListener('hashchange', schedule, { signal: abort.signal });
        document.addEventListener('visibilitychange', schedule, { signal: abort.signal });
        preference.addEventListener('change', schedule, { signal: abort.signal });
        update();
      }
      disconnectedCallback() {
        this.stopEvents?.abort();
        this.stopEvents = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-project-stages"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('tl-project-flow')) {
    customElements.define('tl-project-flow', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.list = this.querySelector('.tl-project-stages__list');
        this.stages = [...this.querySelectorAll('.tl-project-stages__stage')];
        if (!this.list || !this.stages.length) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
        window.addEventListener('scroll', this.queue, {passive: true, signal: this.controller.signal});
        window.addEventListener('resize', this.queue, {passive: true, signal: this.controller.signal});
        this.motion.addEventListener('change', this.queue, {signal: this.controller.signal});
        if (window.ResizeObserver) { this.resize = new ResizeObserver(this.queue); this.resize.observe(this); }
        this.update();
      }
      update() {
        const bounds = this.list.getBoundingClientRect();
        const readingLine = innerHeight * .48;
        const progress = Math.min(1, Math.max(0, (readingLine - bounds.top) / Math.max(1, bounds.height)));
        this.list.style.setProperty('--tl-project-progress', this.motion.matches ? '0' : progress.toFixed(4));
        let active = this.stages.findIndex(stage => stage.getBoundingClientRect().bottom > readingLine);
        if (active < 0) active = this.stages.length - 1;
        const visible = bounds.top < innerHeight && bounds.bottom > 0;
        this.stages.forEach((stage, i) => stage.toggleAttribute('data-current', visible && i === active));
      }
      disconnectedCallback() { this.controller?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-purchase-worksheet"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-purchase-worksheet')) {
    customElements.define('tl-purchase-worksheet', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('[data-worksheet-form]');
        const list = this.querySelector('[data-worksheet-rows]');
        const status = this.querySelector('[data-worksheet-status]');
        const add = this.querySelector('[data-worksheet-add]');
        const rows = () => [...list.querySelectorAll('.tl-worksheet__row')];
        form.addEventListener('submit', event => event.preventDefault());
        form.addEventListener('invalid', event => { const row = event.target.closest('details'); if (row) row.open = true; }, true);
        list.addEventListener('input', event => {
          if (event.target.dataset.field !== 'position') return;
          const row = event.target.closest('details');
          row.querySelector('[data-row-title]').textContent = event.target.value.trim() || `${this.dataset.rowLabel} ${rows().indexOf(row) + 1}`;
        });
        add.addEventListener('click', () => {
          if (rows().length >= 20) { status.textContent = this.dataset.limit; return; }
          const fragment = this.querySelector('[data-worksheet-template]').content.cloneNode(true);
          fragment.querySelector('[data-row-title]').textContent = `${this.dataset.rowLabel} ${rows().length + 1}`;
          list.append(fragment);
          rows().at(-1).querySelector('input').focus();
          status.textContent = this.dataset.added;
          add.disabled = rows().length >= 20;
        });
        this.querySelector('[data-worksheet-export]').addEventListener('click', () => {
          if (!form.reportValidity()) return;
          const meta = [...form.querySelectorAll('[data-meta]')];
          const fields = [...this.querySelector('[data-worksheet-template]').content.querySelectorAll('[data-field]')];
          const heading = element => element.closest('label').firstChild.textContent.trim();
          const note = this.querySelector('[data-worksheet-note]').textContent.trim();
          const data = [[...meta.map(heading), ...fields.map(heading), this.dataset.noteLabel]];
          rows().forEach(row => {
            const values = [...row.querySelectorAll('[data-field]')].map(input => input.tagName === 'SELECT' ? (input.value ? input.selectedOptions[0].textContent : '') : input.value);
            data.push([...meta.map(input => input.value), ...values, note]);
          });
          const quote = value => {
            let clean = String(value).trim();
            if (/^[=+\-@]/.test(clean)) clean = "'" + clean;
            return '"' + clean.replace(/"/g, '""') + '"';
          };
          const csv = '\uFEFF' + data.map(row => row.map(quote).join(',')).join('\r\n');
          const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Taillai-purchase-worksheet.csv';
          link.click();
          setTimeout(() => URL.revokeObjectURL(url), 1000);
          status.textContent = this.dataset.downloaded;
        });
        this.querySelector('[data-worksheet-actions]').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-quote"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-quote-form')) {
    customElements.define('tl-quote-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const button = this.querySelector('[data-quote-submit]');
        const result = this.querySelector('[data-quote-result]');
        if (result) result.focus({ preventScroll: true });
        if (!form || !button) return;
        const modelInput = form.querySelector('[name="contact[model]"]');
        const parameters = new URLSearchParams(window.location.search);
        const requestedModel = parameters.get('model');
        if (modelInput && !modelInput.value.trim() && requestedModel) {
          modelInput.value = requestedModel.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 80);
        }
        const messageInput = form.querySelector('[name="contact[body]"]');
        const brief = parameters.get('brief');
        if (messageInput && !messageInput.value.trim() && brief) {
          messageInput.value = brief.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').trim().slice(0, 4000);
        }
        const requestType = form.querySelector('[name="contact[request_type]"]');
        const typeMap = {home: 'Private home', wholesale: 'Wholesale', project: 'Project'};
        if (requestType && !requestType.value && typeMap[parameters.get('type')]) requestType.value = typeMap[parameters.get('type')];
        const reset = () => {
          button.disabled = false;
          button.textContent = button.dataset.idleLabel;
          form.removeAttribute('aria-busy');
        };
        this.handlePageShow = reset;
        window.addEventListener('pageshow', this.handlePageShow);
        form.addEventListener('submit', (event) => {
          queueMicrotask(() => {
            if (event.defaultPrevented) return;
            button.disabled = true;
            button.textContent = button.dataset.pendingLabel;
            form.setAttribute('aria-busy', 'true');
            this.resetTimer = window.setTimeout(reset, 15000);
          });
        });
      }
      disconnectedCallback() {
        window.removeEventListener('pageshow', this.handlePageShow);
        window.clearTimeout(this.resetTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-resource-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-resource-library')) {
    customElements.define('tl-resource-library', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const input = this.querySelector('[data-resource-search]');
        const tools = this.querySelector('[data-resource-tools]');
        const counter = this.querySelector('[data-resource-count]');
        const empty = this.querySelector('[data-resource-empty]');
        const rows = [...this.querySelectorAll('[data-resource-row]')];
        if (!input || !tools || !counter || !empty) return;
        const search = () => {
          const words = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
          let count = 0;
          rows.forEach(row => {
            const text = row.textContent.toLocaleLowerCase();
            const match = words.every(word => text.includes(word));
            row.hidden = !match;
            if (match) count += 1;
          });
          counter.textContent = counter.dataset.template.replace('%count%', String(count));
          empty.hidden = count !== 0;
        };
        input.addEventListener('input', search);
        tools.hidden = false;
        search();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-solution-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-solution-builder')) {
    customElements.define('tl-solution-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('[data-builder-form]');
        const button = this.querySelector('[data-builder-generate]');
        const result = this.querySelector('[data-builder-result]');
        const preview = this.querySelector('[data-builder-preview]');
        const brief = this.querySelector('[data-builder-brief]');
        const link = this.querySelector('[data-builder-continue]');
        const status = this.querySelector('[data-builder-status]');
        if (!form || !button || !result || !preview || !brief || !link) return;
        const destination = new URL(link.href, window.location.href);
        const progressPanel = this.querySelector('[data-builder-progress-panel]');
        const progress = this.querySelector('[data-builder-progress]');
        const completed = this.querySelector('[data-builder-completed]');
        const questions = [...this.querySelectorAll('[data-builder-question]')];
        const steps = [...this.querySelectorAll('[data-builder-step]')];
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const animations = new WeakMap();
        const updateProgress = event => {
          let count = 0;
          questions.forEach((question, index) => {
            const answered = Boolean(question.querySelector('input:checked'));
            if (answered) count += 1;
            if (steps[index]) steps[index].dataset.answered = String(answered);
          });
          if (progress) progress.value = count;
          if (completed) completed.textContent = String(count);
          if (event?.type !== 'change' || event.target.type !== 'radio' || preference.matches) return;
          const question = event.target.closest('[data-builder-question]');
          if (question && typeof question.animate === 'function') {
            animations.get(question)?.cancel();
            animations.set(question, question.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }], { duration: 360, easing: 'cubic-bezier(.22,.68,0,1)' }));
          }
        };
        let generatedSignature = null;
        let stale = false;
        const sourceLines = () => {
          const lines = [this.dataset.summaryTitle || ''];
          this.querySelectorAll('[data-builder-question]').forEach(question => {
            const choice = question.querySelector('input:checked');
            if (choice) lines.push(`${question.dataset.label}: ${choice.value}`);
          });
          this.querySelectorAll('[data-builder-area], [data-builder-city], [data-builder-extra]').forEach(field => {
            if (field.value.trim()) lines.push(`${field.dataset.label}: ${field.value.trim()}`);
          });
          return lines.filter(Boolean);
        };
        const setStatus = message => {
          if (!status) return;
          status.textContent = this.querySelector(`[data-builder-${message}]`)?.textContent || '';
          status.dataset.stale = String(stale);
        };
        const updateLink = () => {
          if (generatedSignature === null || stale) {
            link.href = `#${button.id}`;
            if (stale) {
              link.setAttribute('aria-disabled', 'true');
              if (status) link.setAttribute('aria-describedby', status.id);
            }
            return;
          }
          link.removeAttribute('aria-disabled');
          link.removeAttribute('aria-describedby');
          if (destination.origin !== window.location.origin) return;
          const url = new URL(destination);
          if (!url.searchParams.has('type')) url.searchParams.set('type', 'home');
          url.searchParams.delete('brief');
          if (brief.value.trim()) url.searchParams.set('brief', brief.value.trim().slice(0, 4000));
          link.href = `${url.pathname}${url.search}${url.hash}`;
        };
        const refreshSourceState = () => {
          if (generatedSignature === null) return;
          stale = JSON.stringify(sourceLines()) !== generatedSignature;
          setStatus(stale ? 'changed' : 'ready');
          updateLink();
        };
        const generate = message => {
          if (!form.reportValidity()) return;
          const lines = sourceLines();
          generatedSignature = JSON.stringify(lines);
          stale = false;
          brief.value = lines.join('\n').slice(0, 4000);
          result.hidden = false;
          preview.hidden = true;
          setStatus(message);
          updateLink();
          brief.focus();
        };
        form.addEventListener('submit', event => {
          event.preventDefault();
          generate('ready');
        });
        form.addEventListener('input', refreshSourceState);
        form.addEventListener('change', updateProgress);
        form.addEventListener('change', refreshSourceState);
        brief.addEventListener('input', updateLink);
        link.addEventListener('click', event => {
          if (generatedSignature === null) {
            event.preventDefault();
            generate('review-first');
            return;
          }
          refreshSourceState();
          if (stale) {
            event.preventDefault();
            button.focus();
            return;
          }
          updateLink();
        });
        button.hidden = false;
        if (progressPanel) progressPanel.hidden = false;
        updateProgress();
        updateLink();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-technical-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-technical-catalog')) {
    customElements.define('tl-technical-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const rows = [...this.querySelectorAll('[data-tech-record]')];
        const filter = this.querySelector('[data-tech-filter]');
        const count = this.querySelector('[data-tech-count]');
        filter.addEventListener('change', () => {
          rows.forEach(row => { row.hidden = filter.value !== 'all' && row.dataset.family !== filter.value; });
          count.textContent = rows.filter(row => !row.hidden).length;
        });
        this.querySelector('[data-tech-export]').addEventListener('click', () => {
          const clean = value => String(value).replace(/\s+/g, ' ').trim();
          const quote = value => '"' + clean(value).replace(/"/g, '""') + '"';
          const header = [...this.querySelectorAll('thead th')].map(cell => cell.textContent);
          const note = this.querySelector('.tl-tech__note').textContent;
          const data = [[...header, this.dataset.noteLabel]];
          rows.filter(row => !row.hidden).forEach(row => {
            const source = [...row.querySelectorAll('dt')].map(term => `${term.textContent}: ${term.nextElementSibling.textContent}`).join(' | ');
            data.push([
              `${row.querySelector('th strong').textContent} | ${row.querySelector('th span').textContent}`,
              ...[...row.children].slice(1, 4).map(cell => cell.innerText), source, note
            ]);
          });
          const csv = '\uFEFF' + data.map(row => row.map(quote).join(',')).join('\r\n');
          const objectUrl = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = 'Taillai-' + filter.value + '-technical-data.csv';
          link.click();
          setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        });
        this.querySelector('[data-tech-controls]').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-documents"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-documents')){customElements.define('tl-v9-biz-documents',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.animations.push(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal:this.abort.signal});}select(index,animate=true){this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches)this.animations.push(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-gallery')){customElements.define('tl-v9-biz-gallery',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.animations.push(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal:this.abort.signal});}select(index,animate=true){this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches)this.animations.push(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-journey"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-journey')){customElements.define('tl-v9-biz-journey',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.animations.push(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal:this.abort.signal});}select(index,animate=true){this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches)this.animations.push(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-system"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-system')){customElements.define('tl-v9-biz-system',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.animations.push(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal:this.abort.signal});}select(index,animate=true){this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches)this.animations.push(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-biz-workbench"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tl-v9-biz-workbench')){customElements.define('tl-v9-biz-workbench',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.buttons=[...this.querySelectorAll('[data-v9-tab]')];this.panels=[...this.querySelectorAll('[data-v9-panel]')];const tabs=this.querySelector('[data-v9-tabs]');if(tabs&&this.buttons.length){tabs.hidden=false;tabs.setAttribute('role','tablist');this.buttons.forEach((button,i)=>{button.setAttribute('role','tab');button.addEventListener('click',()=>this.select(i),{signal:this.abort.signal});button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%this.buttons.length;else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+this.buttons.length)%this.buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.buttons.length-1;else return;event.preventDefault();this.select(next);this.buttons[next].focus();},{signal:this.abort.signal});});this.select(0,false);}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.observer.unobserve(entry.target);if(!this.motion.matches)this.animations.push(entry.target.animate([{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'}));}}),{threshold:.15});this.querySelectorAll('[data-v9-reveal]').forEach(e=>this.observer.observe(e));}this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal:this.abort.signal});}select(index,animate=true){this.dataset.active=String(index+1);this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>{p.hidden=i!==index;p.setAttribute('role','tabpanel');if(i===index&&animate&&!this.motion.matches)this.animations.push(p.animate([{opacity:.2,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'ease-out'}));});}disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-cat-stage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-v9-cat-stage')) {
  customElements.define('tl-v9-cat-stage', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.dataset.inview = 'true';
        this.observer.disconnect();
      }, { threshold: .08 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-guide-check"] && !Shopify.designMode) return;
  try {
    
function v9GuideChecks(root=document){root.querySelectorAll('[data-v9g-check]').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='true';const progress=section.querySelector('[data-v9g-progress]');progress.hidden=false;const inputs=[...section.querySelectorAll('input[type=checkbox]')];function update(){const count=inputs.filter(input=>input.checked).length;section.querySelector('[data-v9g-count]').textContent=count;section.querySelector('[data-v9g-bar]').style.width=(inputs.length?count/inputs.length*100:0)+'%';}inputs.forEach(input=>input.addEventListener('change',update));update();});}v9GuideChecks();document.addEventListener('shopify:section:load',event=>v9GuideChecks(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-guide-cost"] && !Shopify.designMode) return;
  try {
    
function v9GuideCosts(root=document){root.querySelectorAll('[data-v9g-cost]').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='true';section.querySelector('[data-v9g-inputs]').hidden=false;const fields=Object.fromEntries([...section.querySelectorAll('input')].map(input=>[input.name,input]));let formatter;try{formatter=new Intl.NumberFormat(document.documentElement.lang||'ru',{maximumFractionDigits:1});}catch{formatter=new Intl.NumberFormat('ru',{maximumFractionDigits:1});}function update(){const heat=fields.heat.valueAsNumber,energy=fields.energy.valueAsNumber,efficiency=fields.efficiency.valueAsNumber/100,tariff=fields.tariff.valueAsNumber;const valid=['heat','energy','efficiency'].every(name=>fields[name].value!==''&&fields[name].checkValidity())&&[heat,energy,efficiency].every(value=>Number.isFinite(value)&&value>0);section.querySelector('[data-v9g-error]').hidden=valid;const volume=valid?heat/(energy*efficiency):NaN;section.querySelector('[data-v9g-volume]').textContent=Number.isFinite(volume)?formatter.format(volume):'—';section.querySelector('[data-v9g-cost-value]').textContent=Number.isFinite(volume)&&Number.isFinite(tariff)&&fields.tariff.checkValidity()?formatter.format(volume*tariff):'—';}Object.values(fields).forEach(input=>input.addEventListener('input',update));update();});}v9GuideCosts();document.addEventListener('shopify:section:load',event=>v9GuideCosts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-guide-mode"] && !Shopify.designMode) return;
  try {
    
function v9GuideModes(root=document){root.querySelectorAll('div[data-v9g-mode]').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='true';section.querySelector('[data-v9g-mode-buttons]').hidden=false;const buttons=[...section.querySelectorAll('button[data-v9g-mode]')];function show(mode){section.querySelector('.v9g-mode__drawing').dataset.season=mode;buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.v9gMode===mode)));section.querySelectorAll('[data-v9g-panel]').forEach(panel=>panel.hidden=panel.dataset.v9gPanel!==mode);}buttons.forEach(button=>button.addEventListener('click',()=>show(button.dataset.v9gMode)));show('summer');});}v9GuideModes();document.addEventListener('shopify:section:load',event=>v9GuideModes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-intake-paths"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('tl-intake-paths'))customElements.define('tl-intake-paths',class extends HTMLElement{
    connectedCallback(){this.handle=e=>{const link=e.target.closest('[data-intake-type]');if(!link)return;const target=document.querySelector('#request-form');const select=target?.querySelector('select[name="contact[request_type]"]');if(!select)return;const value=link.dataset.intakeType;if(!Array.from(select.options).some(o=>o.value===value))return;e.preventDefault();select.value=value;select.dispatchEvent(new Event('change',{bubbles:true}));this.querySelectorAll('[data-intake-type]').forEach(a=>a.classList.toggle('is-selected',a===link));target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});select.focus({preventScroll:true})};this.addEventListener('click',this.handle)}
    disconnectedCallback(){this.removeEventListener('click',this.handle)}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-v9-market-opening"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('tl-market-opening'))customElements.define('tl-market-opening',class extends HTMLElement{
    connectedCallback(){this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.stop=()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel())};this.motion.addEventListener('change',this.stop);if(!window.IntersectionObserver)return;this.observer=new IntersectionObserver(entries=>{if(!entries.some(e=>e.isIntersecting))return;this.observer.disconnect();if(this.motion.matches)return;this.querySelectorAll('.tl-market-opening__nodes li').forEach((el,i)=>{if(el.animate)this.animations.push(el.animate([{transform:'translateY(12px)'},{transform:'translateY(0)'}],{duration:420,delay:i*65,easing:'cubic-bezier(.2,.7,.2,1)'}))})},{threshold:.15});this.observer.observe(this)}
    disconnectedCallback(){this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());this.motion?.removeEventListener('change',this.stop)}
  });

  } catch(e) { console.error(e); }
})();
})();
